export default "__VITE_ASSET__CzUJaraV__"